// GA4 custom events. Silent no-op when gtag isn't loaded (ad blockers, tests).
export function track(name, params = {}) {
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch { /* ignore */ }
}
